import React from 'react';
import PropTypes from 'prop-types';
import REDUCER_KEY from 'reducers/reducer.keys';
import { Standard } from 'components/Page';
import config from './config';

const LegTypes = ({ permissions }) => (
  <Standard
    canAdmin={permissions.CanAdminAvailabilities()
      .hasPermissions()}
    reducer={{
      item: REDUCER_KEY.availabilityLegType,
      list: REDUCER_KEY.availabilityLegTypes
    }}
    config={config}
    permissions={permissions}
  />
);

LegTypes.propTypes = {
  permissions: PropTypes.object.isRequired
};

export default LegTypes;
